var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-progress',{class:("my-2 " + _vm.color + " Progress-bar"),attrs:{"value":_vm.value,"max":_vm.total}})}
var staticRenderFns = []

export { render, staticRenderFns }